<template>
	<div>
		<div class="changeBidderEmailViewModule">
			<v-app id="inspire">
				<v-content>
					<v-container fluid fill-height>
						<v-layout align-center justify-center>
							<v-flex class="change-bidder-email-view-view" xs12 sm8 md4>
								<v-card class="elevation-12" v-if="this.sent">
									<v-toolbar dark color="primary">
										<v-layout justify-center class="title">
											Na podany adres wysłano link do zmiany adresu email
										</v-layout>
									</v-toolbar>
								</v-card>
								<v-card class="elevation-12" v-else>
									<v-flex dark color="primary" v-if="this.error">
										<h3 style="color: red;">Podany email organizacji nie pasuje do żadnego
											konta</h3>
									</v-flex>
									<v-spacer></v-spacer>
									<v-toolbar dark color="primary">
										<v-toolbar-title>Zmiana adresu email oferenta</v-toolbar-title>
										<v-spacer></v-spacer>
										<v-btn
											icon
											large
											target="_blank"
											slot="activator"
										>
										</v-btn>
									</v-toolbar>
									<v-card-text>
										<v-text-field prepend-icon="person"
											name="email"
											aria-label="email"
											browser-autocomplete="off"
											label="E-mail organizacji"
											for="change-bidder-email"
											id="change-bidder-email"
											v-model="formData.email"
											type="text"></v-text-field>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="primary" @click="sendEmail">Zmień adres email</v-btn>
									</v-card-actions>
								</v-card>
							</v-flex>
						</v-layout>
					</v-container>
				</v-content>
			</v-app>
		</div>
	</div>
</template>

<script>
	import {Api} from "../api";

	export default {
		name: "ChangeBidderEmailView",

		data() {
			return {
				formData: {
					email: "",
				},
				sent: false,
				error: false,
			};
		},

		methods: {
			sendEmail() {
				Api.post(this, "/bidder/change-bidder-email", this.formData, response => {
					if (response.status === "OK") {
						this.sent = true;
					} else {
						this.error = true;
					}

				});
			},
		},
	};
</script>

<style scoped>

</style>
